import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import _ from 'lodash';
import style from './SupportLink.css';

const { supportCta: supportTitle } = window.Language;
const supportUrl = _.get(window.ExternalConfig, 'support.url');

const SupportLink = ({ theme, title, url } = {}) => {
  const props = {
    href: url,
    rel: 'noopener noreferrer',
    title,
    target: '_blank',
    className: classNames([style.support, theme.support]),
  };
  return <a {...props}>{title}</a>;
};

SupportLink.defaultProps = {
  theme: {},
  title: supportTitle,
  url: supportUrl,
};

SupportLink.propTypes = {
  theme: PropTypes.shape({}),
  title: PropTypes.string,
  url: PropTypes.string,
};

export default SupportLink;
